import audio from '../../../../assets/audio/kids-tracks/Text5.mp3';
import image1 from '../../../../assets/images/games/zdar-kids-game/hints/6-1.gif';
import image2 from '../../../../assets/images/games/zdar-kids-game/hints/6-2.gif';

export const step6musketeer = {
    id: 6,
    title: 'Mušketýr',
    taskText: `
        <p>
            Koukám, že ty opravdu všechno znáš, zatím nám to spolu pěkně jde. Za odměnu nám mušketýrův pejsek ukáže cestu kudy ke hraběnce, 
            co tu kousek odsud sedává. Ta by mohla o té barvě vědět víc, patří jí prý ten zámek, u kterého jsme se potkali.
        </p>
    `,
    continueButtonText: 'Jsme na místě',
    cipher: {
        label: 'Úkol',
        text: 'Jděte po fotkách kam vás pejsek nasměroval. Pozor na auta!',
        images: [image1, image2],
    },
    audio: audio,
    points: false,
};
